/**
 * ローディングコンポーネント
 */

import React from 'react';

interface LoadingProps {
  message?: string;
}

export const Loading: React.FC<LoadingProps> = ({ message = '読み込み中...' }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white p-3 rounded-lg shadow-xl text-center">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mx-auto mb-1"></div>
        <p className="text-gray-700 text-xs">{message}</p>
      </div>
    </div>
  );
};
